import { errors as joseErrors } from "jose";

/**
 * Classify a `jwtVerify` throw into a case-distinguishing telemetry reason:
 * an expired token, a wrong issuer or audience, an unknown `kid` (key
 * rotation), a JWKS timeout, a signature failure — which is also how jose
 * reports a token signed with an algorithm outside the pinned `algorithms` —
 * and a JWKS-fetch failure each get their own reason instead of collapsing
 * into one bucket. The reasons are telemetry vocabulary, so they must not be
 * renamed.
 */
export function classifyJoseError(error: unknown): string {
  if (error instanceof joseErrors.JWTExpired) return "expired";
  if (error instanceof joseErrors.JWTClaimValidationFailed) {
    if (error.claim === "iss") return "issuer";
    if (error.claim === "aud") return "audience";
    return `claim_${error.claim}`;
  }
  if (error instanceof joseErrors.JWKSNoMatchingKey) return "no_matching_key";
  if (error instanceof joseErrors.JWKSTimeout) return "jwks_timeout";
  if (error instanceof joseErrors.JWSSignatureVerificationFailed) {
    return "signature";
  }
  // Any other JWKS-fetch failure (non-200, unparsable JSON) or a raw network
  // error from the underlying `fetch` — neither is a signature mismatch.
  return "jwks_fetch_failed";
}
